import { render } from "./user.vue?vue&type=template&id=00a11263"
import script from "./user.vue?vue&type=script&lang=js"
export * from "./user.vue?vue&type=script&lang=js"

import "./user.vue?vue&type=style&index=0&id=00a11263&lang=less"

import exportComponent from "D:\\AICodeSpace\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__